/* src/app/common/components/header/header.component.scss */
:host::ng-deep .header-bg {
  position: relative;
}
:host::ng-deep .header-bg::before {
  position: absolute;
  content: "";
  background: #266cb5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  :host::ng-deep a.text-decoration-none.d-flex.align-items-center.main-logo h1 {
    font-size: 0.9rem;
    margin-bottom: 0 !important;
  }
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  :host::ng-deep a.text-decoration-none.d-flex.align-items-center.main-logo h1 {
    font-size: 0.95rem;
    margin-bottom: 0 !important;
  }
}
:host::ng-deep .navbar-nav {
  gap: 18px;
  margin: auto;
}
@media screen and (max-width: 1200px) {
  :host::ng-deep .navbar-nav {
    gap: 11px;
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  :host::ng-deep .navbar-nav {
    margin: unset;
    text-align: left;
    gap: 0.25rem;
    margin-top: 0.714rem;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  :host::ng-deep .navbar-nav {
    margin: unset;
    text-align: left;
    gap: 0.25rem;
    margin-top: 0.714rem;
  }
}
@media (max-width: 575.98px) {
  :host::ng-deep .navbar-nav {
    margin: unset;
    text-align: left;
    gap: 0.25rem;
    margin-top: 0.714rem;
  }
}
@media (min-width: 1400px) {
  :host::ng-deep .navbar-nav {
    gap: 24px;
  }
}
@media (min-width: 1600px) {
  :host::ng-deep .navbar-nav {
    gap: 24px;
  }
}
:host::ng-deep .navbar-nav .nav-item {
  transition: all 0.25s;
}
:host::ng-deep .navbar-nav .nav-item a {
  transition: all 0.25s;
  border-radius: 0.286rem;
  font-weight: 500;
  border: 1px solid transparent;
  padding: 5px 0px;
  color: var(--color-gray21);
  font-size: 16px;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    border: 1px solid #F5F5F5;
    padding: 0.5rem;
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    border: 1px solid #F5F5F5;
    padding: 0.5rem;
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    border: 1px solid #F5F5F5;
    padding: 0.5rem;
    font-size: 12px;
  }
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    font-size: 14px;
    padding: 2px;
  }
}
@media (min-width: 1400px) {
  :host::ng-deep .navbar-nav .nav-item a {
    font-size: 14px;
    padding: 2px;
    line-height: 1;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    font-size: 13px;
    gap: 16px;
  }
}
:host::ng-deep .navbar-nav .nav-item a.active {
  color: var(--bs-orange-theme);
}
@media (min-width: 576px) and (max-width: 767.98px) {
  :host::ng-deep .navbar-nav .nav-item a {
    padding-left: 0.357rem;
    padding-right: 0.357rem;
    font-size: 12px;
  }
}
:host::ng-deep .navbar-nav .nav-item a:hover:not(.active) {
  color: var(--bs-orange-theme);
}
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-toggle {
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-toggle::after {
  transition: transform 0.25s ease;
}
:host::ng-deep .navbar-nav .nav-item.dropdown.show .dropdown-toggle::after {
  transform: rotate(-180deg);
}
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu {
  margin-top: 10px;
  padding: 6px;
  min-width: 200px;
  border: 1px solid var(--color-gray11);
  border-radius: 0.5rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  background-color: var(--body-background);
}
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {
  border-radius: 0.375rem;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-gray21);
  transition: all 0.2s ease;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  :host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {
    padding: 5px 8px;
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  :host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {
    font-size: 12px;
    padding: 5px 8px;
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  :host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item {
    font-size: 12px;
    padding: 5px 8px;
  }
}
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item:hover,
:host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu .dropdown-item.active {
  color: var(--bs-orange-theme);
  background-color: transparent;
}
@media (max-width: 991.98px) {
  :host::ng-deep .navbar-nav .nav-item.dropdown .dropdown-menu {
    position: static;
    float: none;
    width: 100%;
    margin-top: 0.25rem;
    border: none;
    box-shadow: none;
    background: transparent;
    padding-left: 1rem;
  }
}
.notifyCount {
  padding: 5px;
  display: inline-block;
  border-radius: 50%;
  top: 14px;
  left: 66%;
}
@media screen and (max-width: 1400px) and (min-width: 1024px) {
  .notifyCount {
    top: 10px;
  }
}
.landing-page {
  background-color: var(--bg-white);
}
.breadcrumbs {
  display: flex;
  align-items: center;
  box-shadow: 0rem 0.357rem 0.357rem rgba(0, 0, 0, 0.1);
  position: relative;
}
.breadcrumbs a {
  font-size: 0.857rem;
  font-weight: 600;
  line-height: 2rem;
  text-decoration: none;
  color: var(--bs-orange-theme);
}
.breadcrumbs span {
  font-size: 0.857rem;
  font-weight: 600;
  line-height: 2rem;
}
.navbar-toggler {
  background: var(--bs-orange-theme);
  position: absolute;
  top: -47px;
  left: auto;
  right: 0;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 0.313rem;
  cursor: pointer;
  overflow: hidden;
  outline: 0;
  box-shadow: none;
}
.navbar-toggler .navbar-toggler-area {
  transition: all 0s;
}
.navbar-toggler span {
  position: absolute;
  background: #fff;
  display: inline-block;
  border-radius: 0.188rem;
  left: 0.75rem;
  height: 0.188rem;
  transition: all 0.4s;
  width: 50%;
}
.navbar-toggler span:nth-of-type(1) {
  top: 0.75rem;
}
.navbar-toggler span:nth-of-type(2) {
  top: 1.438rem;
}
.navbar-toggler span:nth-of-type(3) {
  top: 2.125rem;
}
.navbar-toggler:not(.collapsed) .navbar-toggler-area {
  transform: rotateX(360deg);
}
.navbar-toggler:not(.collapsed) span:nth-of-type(1) {
  width: 100%;
  top: 0.25rem;
  left: 0;
  transform: translateY(-0.375rem) rotate(-135deg);
}
.navbar-toggler:not(.collapsed) span:nth-of-type(2) {
  opacity: 0;
}
.navbar-toggler:not(.collapsed) span:nth-of-type(3) {
  width: 100%;
  top: 0.188rem;
  left: 0;
  transform: translateY(-0.375rem) rotate(135deg);
}
.notification-btn > i {
  font-size: 1.5rem !important;
}
.red-dot {
  height: 6px;
  width: 6px;
  background-color: #FF764E;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 20px;
}
.header-btn-wrapper .btn-primary p {
  font-size: 13px;
  font-weight: 400;
}
.header-btn-wrapper button {
  padding: 10px 15px 12px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 16px;
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .header-btn-wrapper button {
    padding: 3px 15px 5px;
    font-size: 14px;
    border-radius: 8px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .header-btn-wrapper button {
    padding: 5px 15px 6px;
    font-size: 13px;
    border-radius: 8px;
  }
}
.header-btn-wrapper button.spacing {
  position: relative;
}
.header-btn-wrapper button.spacing::before {
  content: "";
  left: -14px;
  height: 24px;
  width: 1px;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translateY(-50%);
  background-color: #08122B;
}
@media (max-width: 767px) {
  .header-btn-wrapper button {
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 8px !important;
  }
}
.header-btn-wrapper button span {
  font-size: 12px;
  font-weight: 700;
}
.header-btn-wrapper button span.small {
  font-size: 10px;
}
@media (max-width: 767px) {
  .header-btn-wrapper button span {
    font-size: 12px;
    font-weight: 500;
  }
}
.mahasarathi-text {
  font-size: 18px;
  font-family: "Noto Sans ExtraBold";
  color: var(--color-black);
}
.header-main-container {
  border-bottom: 1px solid var(--color-gray11);
  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .header-main-container {
    position: fixed;
    z-index: 99;
    width: 100%;
    background-color: var(--body-background);
  }
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .header-main-container {
    position: fixed;
    z-index: 99;
    width: 100%;
    background-color: var(--body-background);
  }
}
@media (min-width: 1400px) {
  .header-main-container {
    position: fixed;
    z-index: 99;
    width: 100%;
    background-color: var(--body-background);
  }
}
.divided-both {
  position: relative;
}
.divided-both::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 50%;
  background-color: #d9d9d9;
}
.divided-both::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  width: 1px;
  height: 50%;
}
nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  position: relative;
}
.login-btn {
  background-color: var(--text-pink);
  color: white;
  padding: 10px 20px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.login-btn:hover {
  background-color: #e65a00;
}
.dropdown-content {
  display: block;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content a:hover {
  background-color: #f1f1f1;
}
.separator {
  position: relative;
}
.separator::before {
  content: "";
  left: 0;
  height: 30px;
  width: 1px;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translateY(-50%);
  background-color: #d9d9d9;
}
@media screen and (max-width: 991px) {
  .separator::before {
    display: none;
  }
}
@media (max-width: 992px) {
  .dropdown-content {
    display: block;
    position: relative;
    box-shadow: none;
    background-color: transparent;
  }
}
.marquee-container {
  background: #fdeeee;
  border-top: 1px solid var(--red-border-dashboard);
  border-radius: 0;
  padding: 8px 15px;
  color: #222;
  font-family: Arial, sans-serif;
  font-size: 13px;
  width: 100%;
  line-height: 1;
  border-bottom: 1px solid var(--red-border-dashboard);
}
.marquee-container img {
  margin-bottom: 1px;
}
.marquee-container marquee {
  display: flex;
  align-items: center;
}
.marquee-container a {
  color: var(--text-red);
  text-decoration: underline;
  margin-left: 5px;
}
.header-profile .header-profile-photo {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.welcome-popup-overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: welcomeOverlayFade 0.5s ease;
}
.welcome-popup-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 44px 32px 32px;
  width: 90%;
  max-width: 500px;
  text-align: center;
  animation: welcomeCardPop 0.5s ease;
}
.welcome-popup-icon {
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--bs-orange-theme);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.welcome-popup-icon i {
  color: #fff;
  font-size: 26px;
}
.welcome-popup-title {
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 20px;
  color: #222;
}
.welcome-popup-message {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}
.welcome-popup-btn {
  background-color: var(--bs-orange-theme);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 0;
  width: 100%;
  font-weight: 600;
  transition: background-color 0.5s ease;
}
.welcome-popup-btn:hover {
  background-color: var(--bg-darked-theme);
  color: #fff;
}
@keyframes welcomeCardPop {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes welcomeOverlayFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media screen and (max-width: 1199px) {
  .container {
    padding: 0 15px !important;
  }
}
/*# sourceMappingURL=header.component-PBGYFRY7.css.map */
